import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SiDashboardCardComponent } from '@siemens/element-ng/dashboard';

@Component({
    selector: 'tran-application-detail-dashboard-box',
    imports: [SiDashboardCardComponent, TranslateModule],
    templateUrl: './application-detail-dashboard-box.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationDetailDashboardBoxComponent {
    public readonly heading = input<string>();
}
